import { Component, ContentChild, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BalanceService, CompletedPollQuestion, config, GamesGroupService, GroupType, IAnswer, IPollQuestion } from '@fgb/core';

@Component({
  selector: 'fgbcl-game-polls-question-list',
  templateUrl: './game-polls-question-list.component.html',
  styleUrl: './game-polls-question-list.component.scss',
})
export class GamePollsQuestionListComponent implements OnInit {
  @Input() pollsQuestions: IPollQuestion[] = [];
  groupType = GroupType.Poll;
  @Output() answerSelected = new EventEmitter<any>();
  submittedPollId!: number;
  isSubmittingAnswer: boolean = false;
  @Input() isExternal: boolean = false;
  @Input() groupId: number;
  @ContentChild('submissionFormContent', { static: false }) submissionFormTemplate: TemplateRef<any>;
  constructor(
    private gamesGroupService: GamesGroupService,
    private balanceService: BalanceService
  ) {}
  ngOnInit(): void {
    this.sortPollsQuestions();
  }

  /**
   * submit poll answer and fetch updated the object with updated result
   * @param answer selected poll answer
   */
  onAnswerSelected(pollId: number, answer: IAnswer) {
    if (this.isSubmittingAnswer) return;
    this.isSubmittingAnswer = true;
    this.submittedPollId = pollId;
    this.gamesGroupService.submitPollAnswer(pollId, answer.Id, this.isExternal).subscribe((res) => {
      const question = this.pollsQuestions.find((q) => q.Id === pollId) as CompletedPollQuestion;
      if (question) {
        question.Answers.forEach((qanswer) => {
          let resultAnswer = res.Answers.find((a) => a.Id === qanswer.Id);
          if (resultAnswer) {
            qanswer.UserSelected = resultAnswer.UserSelected;
            qanswer.Percentage = resultAnswer.Percentage;
          }
        });
        question.PointsAwarded = res.PointsAwarded;
        question.Completed = true;
        question.ImageUrl = question.ImageUrl;
        this.balanceService.addBalance(config.purseConfig.virtualLoyalty, question.PointsAwarded);
      }
      this.isSubmittingAnswer = false;
    });
  }

  sortPollsQuestions() {
    this.pollsQuestions.sort((a, b) => {
      // 1. Featured & Not Completed should come first
      if (a.Featured && !a.Completed && !(b.Featured && !b.Completed)) {
        return -1;
      }
      if (b.Featured && !b.Completed && !(a.Featured && !a.Completed)) {
        return 1;
      }

      // 2. Non-Featured & Not Completed should come next
      if (!a.Completed && b.Completed) {
        return -1;
      }
      if (a.Completed && !b.Completed) {
        return 1;
      }

      // 3. If both have the same status, maintain original order
      return 0;
    });
  }

  areAllPollsCompleted(): boolean {
    return this.pollsQuestions.length > 0 && this.pollsQuestions.every((q) => q.Completed);
  }
}
